import Navbar from "../../components/navbar/Navbar";
// import Leftlayout from "../../components/leftlayout/Leftlayout";
// import Sidebar from "../../components/sidebar/Sidebar";
import LoginPopup from "../login/Login";
import NoticePopup from "../../components/popupfiles/noticepopup/noticePopup";
import ChatPopup from "../../components/popupfiles/chatpopup/chatPopup";
import MainNodeTable from "../../components/mainlayout/mainnodetable";

const NodeTable = () => {
  return (
    <div className="NodeTable">
      <Navbar />
      {/* <Leftlayout /> */}
      <LoginPopup />
      <NoticePopup />
      <ChatPopup />
      <MainNodeTable />
    </div>
  );
};

export default NodeTable;
